<div class="seletor-tags">
  <div class="seletor-tags__container">
    <div class="seletor-tags__input">
      <sgt-tokenfield-input
        [tokens]="selectedTags"
        [settings]="settings?.tokenFieldSettings">
      </sgt-tokenfield-input>
    </div>

    <button
      *ngIf="!showPickList"
      type="button"
      class="btn btn-primary"
      title="Adicionar tags"
      (click)="openPickList()">
      <i class="fas fa-plus"></i>
    </button>

    <button
      *ngIf="showPickList"
      type="button"
      class="btn btn-secondary"
      title="Cancelar seleção de tags"
      (click)="closePickList()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <sgt-pick-list
    *ngIf="showPickList && tags.length > 0"
    [items]="tags"
    [settings]="settings?.pickListSettings"
    (itemsChange)="onTagsChange()"
  >
  </sgt-pick-list>
</div>
